















import { Component, Vue } from "vue-property-decorator";
import CContactForm from "@/components/forms/CContactForm.vue";
import CHeader from "@/components/CHeader.vue";
import CFooter from "@/components/CFooter.vue";
import ContactModule from "@/store/contact";
import { EditStatus } from "../types";

@Component({
  components: {
    CHeader,
    CContactForm,
    CFooter,
  },
})
export default class Contact extends Vue {
  private get EditStatus() {
    return EditStatus;
  }

  private get editStatus() {
    return ContactModule.editStatus;
  }
}
